import { SchemaType } from "../../../yaml-content";
import React from "react";

type Props = {
  schemaRef: SchemaType[];
};

const ResponseSchemaDatatypes = ({ schemaRef = [] }: Props) => {
  // Default to an empty array
  return (
    <div>
      {schemaRef.map((schemaType, index) => {
        let separator = "";
        if (index > 0) {
          separator = ", ";
        }
        return (
          <a href={`#_${schemaType.name}`} key={`#${index}`}>
            {separator}
            <em>{schemaType.name}</em>
          </a>
        );
      })}
    </div>
  );
};
export default ResponseSchemaDatatypes;
